import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { BinderWizardService } from '../services/sections/binder/binder-wizard.service';
import { BinderClassification } from '../models/binder/binder-classification.model';

@Injectable({
	providedIn: 'root'
})
export class BinderClassificationResolver implements Resolve<Observable<BinderClassification[]>> {

	constructor(
		private router: Router,
		private binderWizardService: BinderWizardService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;
		GlobalSettingsService.navigationBarActions.clear();
		GlobalSettingsService.isJobCompletedStatusVisible = false;

		return this.binderWizardService
			.getBinderClassification(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
